import { useBlockProps } from '@wordpress/block-editor';

const View = (props) => {
  const { attributes } = props;
  const blockProps = useBlockProps();

  return (
    <div {...blockProps}>
      <div style={{ backgroundColor: attributes.color, height: attributes.height + 'px' }}></div>
    </div>
  );
};

export default View;
